var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStarOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CED3DA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 9.752l-3.35 1.78c-.242.13-.526-.08-.48-.353l.64-3.77L.1 4.739c-.196-.194-.088-.532.184-.572l3.744-.55L5.703.187c.122-.25.472-.25.594 0l1.675 3.43 3.744.55c.272.04.38.378.184.571l-2.71 2.67.64 3.771c.046.274-.238.482-.48.353L6 9.752z",
    transform: "translate(-72 -552) translate(16 548) translate(56 4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarOff);
export default __webpack_public_path__ + "static/media/ic_star_off.6d482c3d9526610acc510692c1e6f645.svg";
export { ForwardRef as ReactComponent };